import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TrackingPropertiesContext from './TrackingPropertiesContext';

const mapStateToProps = state => ({
  trackingProperties: state.sessionTrackingProperties,
});

class TrackingPropertiesProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    trackingProperties: PropTypes.object,
  };

  render = () => (
    <TrackingPropertiesContext.Provider value={this.props.trackingProperties}>
      {this.props.children}
    </TrackingPropertiesContext.Provider>
  );
}

export default connect(mapStateToProps)(TrackingPropertiesProvider);
